export const colors = {
    loaderColor: "#e55426"
}